import StandardGateway from '@ad-scripts/adapters/gateways/lib/standard_gateway';

/**
 * Recipient Collection Gateway
 */
export default class RecipientCollectionGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/campaigns/:campaignId/recipientcollections/:id');
  }

  add(params, data) {
    const url = this.endpoint.set(params).addUrl;

    const jsonStr = JSON.stringify(data.recipientCollection);
    const jsonBlob = new Blob([jsonStr], {
      type: 'application/json',
    });
    const formData = new FormData();
    formData.append('recipient-collection', jsonBlob);
    formData.append('csv-file', data.csvFile);

    return this.http
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(dto => this.observer.onUpdateSuccess(dto, params))
      .catch(error => this.observer.onUpdateError(error, params));
  }
}
